const LogOutIconVector = (props) => {
  return (
    <svg
      width={16}
      height={14}
      fill="current"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 8.25a.75.75 0 100-1.5.75.75 0 000 1.5zM8.5.5a.5.5 0 00-.576-.494l-7 1.07A.5.5 0 00.5 1.57v10.86a.5.5 0 00.424.494l7 1.071a.5.5 0 00.576-.494v-6.5h5.172l-.997.873a.5.5 0 00.658.752l1.996-1.75a.5.5 0 000-.752l-1.996-1.75a.5.5 0 10-.658.752l.997.874H8.5V.5zm-1 .582V12.92l-6-.92V2l6-.918zM10 13h-.5V8h1v4.5a.5.5 0 01-.5.5zm-.5-8V1h.5a.5.5 0 01.5.5V5h-1z"
        fill="current"
      />
    </svg>
  );
};

export default LogOutIconVector;
